import React from 'react';
import { connect } from 'react-redux';
import { setDialogs } from '../../../actions';
import { setWelfareAnimation, setProperty } from '../../../rootStore';

import './index.scss';

class SignInVipDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

	close = () => {
	  this.props.dialogs.pop();
	  this.props.dispatch(setDialogs(this.props.dialogs));

	  setWelfareAnimation();
	  const { value, welfareType } = this.props.welfareInfo;
	  setProperty({ value, welfareType });
	}

	contentRender = () => {
	  const { welfareInfo = {}, kbApp = {} } = this.props;

	  if (welfareInfo.welfareType === 6) {
	    const userInfo = kbApp.userInfo || {};
	    return (
				<React.Fragment>
					<div className="vipSignIn">
						<div className="congra">签到成功</div>
						<div className="prize">
							<div className="name">{welfareInfo.value}天VIP</div>
							<div className="pic vip"></div>
						</div>
						<div className="status">已领取</div>
						<div className="account">
							使用此账号
							<span className="avator"><img src={userInfo.avatar}/></span>
							{/* <span className="nickname">{userInfo.nickname || ''}</span> */}
						</div>
						<div className="tip">登录 [腾讯视频] 即可使用</div>
						<div className="btn" onClick={this.close} log-click-eltype="confirm">知道了</div>
					</div>
				</React.Fragment>
	    );
	  }
	  return (
		<React.Fragment>
			<div className="vipSignIn coin">
				<div className="congra">签到成功</div>
				<div className="prize">
					<div className="name">{welfareInfo.value}金币</div>
					<div className="pic coin"></div>
				</div>
				<div className="status">已领取</div>
				<div className="btn" onClick={this.close} log-click-eltype="confirm">知道了</div>
			</div>
		</React.Fragment>
	  );
	}

	render() {
	  return (
		<div className="signInVipDialog">
			<div className="dialog">
				{this.contentRender()}
				<div className="close" onClick={this.close} log-click-eltype="close"></div>
			</div>
		</div>
	  );
	}
}

const mapStateToProps = (state) => {
  const { dialogs, kbApp } = state;
  return {
    dialogs,
    kbApp,
  };
};

export default connect(mapStateToProps)(SignInVipDialog);
